export const TILE_SIZE = 16;
export const DEFAULT_ENTITY_SIZE = { width: 32, height: 32 };
export const HANDLE_SIZE = 8;
export const SNAP_GRID = 0.5; // half-tile snap granularity
